import {
    useEffect,
    useState,
} from 'react';
import { get } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';

const HOMEPAGE_WIDGETS_URL = buildSpectateUrl('/homepage/widgets');

export const useHomepageService = () => {
    const [data, setData] = useState(null);

    const getData = async () => {
        const response = await get(HOMEPAGE_WIDGETS_URL);

        if (!response.ok) {
            setData({});

            return;
        }

        const respData = await response.json();
        if (respData) {
            setData(respData);
        } else {
            setData({});
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return data;
};

